const initialState = {
    isCreatingContactSocialMedia: false,
    isUpdatingContactSocialMedia: false,
    socialNetworkBeingDeleted: null
};

export default initialState;
